/**
 *
 * @param el container容器
 * @param itemLength 子元素长度
 * @param space 间距
 */
export function waterfall (el: string, itemLength: number, space?: number): void {
  const waterFallContainer = document.getElementsByClassName(el)[0] as HTMLElement
  const childNodes = waterFallContainer.childNodes
  const heightArray = [], // 存储每列的高度
    columns = 2 // 2列;
  for (let i = 0; i < itemLength; i++) {
    // 遍历所有div，对他们设置left和top值
    const curEl = childNodes[i] as HTMLElement
    const curElW = curEl.offsetWidth
    if (i < columns) { // i < columns说明为第一排
      const extraLeft = i > 0 ? (space || 0) : 0
      curEl.style.top = '0' // 第一排top值为0
      curEl.style.left = i * curElW + extraLeft + 'px' // 第一张left:0,第二张left:...
      heightArray[i] = curEl.offsetHeight + (space || 0) // 第1排直接设置
    } else { // 非第1排
      const minHeight = Math.min(...heightArray) // 找到高度最小值
      const minIndex = heightArray.indexOf(minHeight) // 找到最小值所在列
      const extraLeft = minIndex > 0 ? (space || 0) : 0
      curEl.style.top = minHeight + 'px' // 设置top值
      curEl.style.left = minIndex * curElW + extraLeft + 'px' // 设置left值
      heightArray[minIndex] += curEl.offsetHeight + (space || 0) // 更新高度数组
    }
  }
  waterFallContainer.style.height = Math.max(...heightArray) + 'px'
}
